<div
	class="select-input"
	matTooltip="{{ errorText }}"
	matTooltipClass="pv-tooltip"
	matTooltipPosition="below"
	[class.disabled]="disabled"
	[formGroup]="innerForm"
	[matTooltipDisabled]="!error || !errorText"
>
	<span class="input" [class.is-hidden]="showList || !value" [class.is-placeholder]="selected.size === 0">
		@if (placeholderTemplate && value) {
			<ng-template [ngTemplateOutlet]="placeholderTemplate" [ngTemplateOutletContext]="{ $implicit: selectedValue }" />
		} @else {
			<ng-template #defaultTmpl> {{ fallbackPlaceholder }} </ng-template>
		}
	</span>
	<input
		#input
		formControlName="value"
		type="text"
		[class.is-hidden]="!showList && value"
		[placeholder]="placeholder"
		(blurEvent)="toggle()"
		(focus)="toggle()"
		(keyup)="handleKeyUp($event)"
	/>
	@if (!disabled) {
		<ic-fa-icon icon="search" />
	}
</div>

@if (showList) {
	<div class="select-options">
		<ul #list tabindex="-1">
			@if (multi && selectedItems.length > 0) {
				<div class="selected">
					@if (selectedTemplate) {
						@for (item of selectedItems; track item; let i = $index) {
							<li #listItem (focus)="setItemIndex(i)" (focusClick)="selectOption(item)" (keyup)="handleKeyUp($event)">
								@if (selectedTemplate) {
									<ng-template [ngTemplateOutlet]="selectedTemplate" [ngTemplateOutletContext]="{ $implicit: item }" />
								} @else {
									<ng-template #defaultSelectedTmpl>
										{{ item }}
									</ng-template>
								}
							</li>
						}
					} @else {
						<ng-template #defaultSelectedTmpl>
							@for (item of selectedItems; track item; let i = $index) {
								<li #listItem (focus)="setItemIndex(i)" (focusClick)="selectOption(item)" (keyup)="handleKeyUp($event)">
									@if (itemTemplate) {
										<ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: item }" />
									} @else {
										<ng-template #defaultTmpl> {{ item }} </ng-template>
									}

									<i class="fa fa-times deselect-icon"> </i>
								</li>
							}
						</ng-template>
					}
				</div>
			}

			@if (filteredItems && (filteredItems.length > 0 || selectedItems.length > 0)) {
				@for (item of filteredItems; track item; let i = $index) {
					<li
						#listItem
						(blur)="handleBlur(i)"
						(focus)="setItemIndex(i)"
						(focusClick)="selectOption(item)"
						(keyup)="handleKeyUp($event)"
					>
						@if (itemTemplate) {
							<ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: item }" />
						} @else {
							<ng-template #defaultTmpl> {{ item }} </ng-template>
						}
					</li>
				}
			} @else {
				<ng-container [ngTemplateOutlet]="emptyTmpl" />
			}

			@if (actionTemplate) {
				<li #listItem tabindex="0" (click)="onAction()" (keyup)="handleKeyUp($event)">
					<ng-template [ngTemplateOutlet]="actionTemplate" />
				</li>
			}
		</ul>
	</div>
}

<ng-content select=".errors" />

<ng-template #emptyTmpl>
	<li><ng-template [ngTemplateOutlet]="emptyTemplate" /></li>
</ng-template>
